export default __webpack_public_path__ + "assets/images/4c4df919e6bcb717b6b998d6c742db9a.png";